import {
  Typography,
  Dialog,
  Button,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";

export const CraneHoldToCompleteDialog = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const { t } = useTenantTranslation();

  return (
    <Dialog
      open={open}
      onClose={() => {
        onClose();
      }}
      onClick={() => {
        onClose();
      }}
    >
      <DialogContent>
        <Typography variant="h6">{t("holdToComplete")}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => {
            onClose();
          }}
          size="large"
        >
          {t("confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
